var SENTRY_RELEASE;SENTRY_RELEASE={name: "Thermen Resorts", version: "2.77.0"};